import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { ERRORS } from '@/common/constants/errors';
import { StorageService } from '@/common/integrations/storage/storage.service';
import * as Notifications from 'expo-notifications';

interface NotificationsContextType {
  setNotificationToken: (token: string) => void;
}

const NotificationsContext = createContext<
  NotificationsContextType | undefined
>(undefined);

export const NotificationsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [expoPushToken, setExpoPushToken] = useState<string | null>();
  const [notificationPermission, setNotificationPermission] =
    useState<Notifications.PermissionStatus>();
  const notificationListener = useRef<Notifications.EventSubscription | null>(
    null
  );
  const responseListener = useRef<Notifications.EventSubscription | null>(null);

  const setNotificationToken = async (token: string) => {
    await StorageService.setNotificationToken(token);
    setExpoPushToken(token);
  };

  useEffect(() => {
    const checkStatus = async () => {
      const { status: existingStatus } =
        await Notifications.getPermissionsAsync();

      setNotificationPermission(existingStatus);

      const token = await StorageService.getNotificationToken();
      setExpoPushToken(token);
    };

    checkStatus();
  }, []);

  useEffect(() => {
    // TODO: check if token is null
    // ver se é preciso validar o status da permission
    if (!expoPushToken && notificationPermission !== 'granted') return;

    notificationListener.current =
      Notifications.addNotificationReceivedListener((notification) => {
        // Called when a notification is received while the app is running
        console.log('addNotificationReceivedListener', notification);
      });

    responseListener.current =
      Notifications.addNotificationResponseReceivedListener((response) => {
        // Called when the user taps on a notification
        console.log('addNotificationResponseReceivedListener', response);
      });

    return () => {
      if (notificationListener.current) {
        Notifications.removeNotificationSubscription(
          notificationListener.current
        );
      }
      if (responseListener.current) {
        Notifications.removeNotificationSubscription(responseListener.current);
      }
    };
  }, [expoPushToken, notificationPermission]);
  return (
    <NotificationsContext.Provider
      value={{
        setNotificationToken,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(ERRORS.CONTEXT_VALUE_REQUIRED);
  }
  return context;
};
